var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgLoginType1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1860_96270)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7251 15.2419V15.7353C18.6523 15.6941 18.5368 15.6941 18.4653 15.7353V15.2419C18.5382 15.2006 18.6536 15.2006 18.7251 15.2419Z",
    fill: "#77908C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9725 15.3851L18.9711 15.8786L18.7251 15.737L18.7265 15.2422L18.9725 15.3851Z",
    fill: "#404E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0275 15.4662V15.9597C19.0275 15.9322 19.0083 15.9047 18.9712 15.8841V15.3906C19.0097 15.4112 19.0275 15.4387 19.0275 15.4662Z",
    fill: "#77908C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0271 15.4688V15.9622C19.0258 15.9897 19.0079 16.0158 18.9722 16.0364V15.543C19.0093 15.5224 19.0258 15.4962 19.0271 15.4688Z",
    fill: "#3D4A48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4302 15.6403V16.1338C19.3573 16.0925 19.2419 16.0925 19.1704 16.1338V15.6403C19.2433 15.5991 19.3587 15.5991 19.4302 15.6403Z",
    fill: "#77908C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1729 18.9638L25.1715 19.4587L19.4287 16.1419L19.4301 15.6484L25.1729 18.9638Z",
    fill: "#404E4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2287 19.0522V19.5456C25.2287 19.5181 25.2095 19.4906 25.1724 19.47V18.9766C25.2095 18.9972 25.2287 19.0247 25.2287 19.0522Z",
    fill: "#77908C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2269 19.0391V19.5325C25.2256 19.56 25.2077 19.5861 25.1733 19.6067V19.1133C25.2105 19.0927 25.2269 19.0666 25.2269 19.0391Z",
    fill: "#3D4A48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2933 21.6328V22.1263C30.292 22.2349 30.2191 22.3448 30.0762 22.4273V21.9338C30.2219 21.85 30.2933 21.7414 30.2933 21.6328Z",
    fill: "#BDC2CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1759 19.1172L25.1745 19.6106L10.647 28.0531L10.6483 27.5582L25.1759 19.1172Z",
    fill: "#2F3938"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0442 22.164V22.6575C20.8078 22.5214 20.427 22.5214 20.1934 22.6575V22.164C20.4284 22.028 20.8092 22.0293 21.0442 22.164Z",
    fill: "#9799A2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4683 15.2422L18.467 15.737L3.93945 24.1794L3.94083 23.6846L18.4683 15.2422Z",
    fill: "#5C706D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94024 23.6719V24.1653C3.90312 24.186 3.88525 24.2134 3.88525 24.2409V23.7475C3.88663 23.72 3.9045 23.6925 3.94024 23.6719Z",
    fill: "#77908C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94024 23.849V24.3425C3.90312 24.3219 3.88525 24.2944 3.88525 24.2669V23.7734C3.88525 23.8009 3.9045 23.8284 3.94024 23.849Z",
    fill: "#3D4A48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9752 15.5312L18.9738 16.0261L4.44629 24.4671L4.44766 23.9737L18.9752 15.5312Z",
    fill: "#2F3938"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18824 23.9775L4.18687 24.471L3.93945 24.3294L3.94083 23.8359L4.18824 23.9775Z",
    fill: "#212827"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44769 23.9766V24.47C4.37484 24.5113 4.258 24.5113 4.18652 24.47V23.9766C4.26075 24.0178 4.37758 24.0178 4.44769 23.9766Z",
    fill: "#3D4A48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1716 15.6484L19.1702 16.1419L4.64404 24.5843L4.64542 24.0909L19.1716 15.6484Z",
    fill: "#5C706D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5709 24.1998L24.5696 24.6946L21.0425 22.6575L21.0439 22.1641L24.5709 24.1998Z",
    fill: "#9799A2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64434 24.0938V24.5872C4.60722 24.6078 4.58936 24.6353 4.58936 24.6628V24.1694C4.59073 24.1419 4.6086 24.1144 4.64434 24.0938Z",
    fill: "#77908C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64336 24.2319V24.7253C4.60625 24.7047 4.58838 24.6772 4.58838 24.6497V24.1562C4.58838 24.1837 4.60762 24.2112 4.64336 24.2319Z",
    fill: "#3D4A48"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7505 24.4363V24.9298C24.7505 24.8404 24.69 24.7497 24.5718 24.681V24.1875C24.6914 24.2562 24.7518 24.3456 24.7505 24.4363Z",
    fill: "#9799A2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1943 22.1641L20.1929 22.6589L15.8975 25.1551L15.8988 24.6616L20.1943 22.1641Z",
    fill: "#9799A2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7477 24.4453V24.9388C24.7463 25.0267 24.6886 25.1147 24.5718 25.1821V24.6886C24.6886 24.6213 24.7477 24.5333 24.7477 24.4453Z",
    fill: "#455452"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8981 24.6797V25.1731C15.7813 25.2405 15.7222 25.3285 15.7222 25.4178V24.9244C15.7235 24.8364 15.7813 24.747 15.8981 24.6797Z",
    fill: "#9799A2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9009 25.1849V25.6784C15.7813 25.6096 15.7222 25.5203 15.7222 25.431V24.9375C15.7222 25.0268 15.7826 25.1176 15.9009 25.1849Z",
    fill: "#455452"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5756 24.6953L24.5742 25.1888L20.2788 27.6863L20.2802 27.1915L24.5756 24.6953Z",
    fill: "#35413F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4288 27.1919L19.4275 27.6868L15.9004 25.6497L15.9018 25.1562L19.4288 27.1919Z",
    fill: "#252D2C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.571 24.3574C24.8074 24.4934 24.8088 24.7134 24.5751 24.8494L20.2797 27.3456C20.046 27.4817 19.6652 27.4817 19.4288 27.3456L15.9018 25.3085C15.6667 25.1725 15.6653 24.9512 15.899 24.8165L20.1944 22.3203C20.4281 22.1842 20.8089 22.1856 21.0439 22.3203L24.571 24.3574V24.3574Z",
    fill: "#B7BBC6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.279 27.1797V27.6731C20.0439 27.8092 19.6632 27.8092 19.4268 27.6731V27.1797C19.6646 27.3158 20.0453 27.3158 20.279 27.1797Z",
    fill: "#455452"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3868 27.5576L10.3854 28.0524L4.64258 24.737L4.64395 24.2422L10.3868 27.5576Z",
    fill: "#212827"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6493 27.5547V28.0481C10.5765 28.0894 10.4597 28.0894 10.3882 28.0481V27.5547C10.461 27.5959 10.5792 27.5959 10.6493 27.5547Z",
    fill: "#3D4A48"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.072 21.3089C30.3634 21.4766 30.3648 21.7487 30.0747 21.9164L15.4991 30.3863C15.2105 30.554 14.7417 30.554 14.4503 30.3863L3.10352 23.8353L18.7238 14.7578L30.072 21.3089V21.3089ZM10.6484 27.5575L25.1759 19.1151C25.2474 19.0739 25.246 19.0065 25.1745 18.9653L19.4317 15.6499C19.3602 15.6087 19.2447 15.6087 19.1733 15.6499L4.64575 24.0923C4.57427 24.1335 4.57427 24.2009 4.64575 24.2421L10.3886 27.5575C10.4601 27.5988 10.5783 27.5988 10.6484 27.5575V27.5575ZM20.2798 27.1919L24.5752 24.6957C24.8089 24.5597 24.8075 24.3397 24.5711 24.2037L21.044 22.1666C20.809 22.0305 20.4282 22.0305 20.1945 22.1666L15.8991 24.6627C15.6654 24.7988 15.6668 25.0201 15.9019 25.1548L19.4289 27.1919C19.6653 27.328 20.0461 27.328 20.2798 27.1919ZM4.44782 23.9782L18.9753 15.5358C19.0468 15.4946 19.0454 15.4272 18.974 15.386L18.7279 15.243C18.6564 15.2018 18.541 15.2018 18.4695 15.243L3.94061 23.6841C3.86913 23.7253 3.86913 23.7927 3.94061 23.8339L4.18665 23.9769C4.2595 24.0181 4.37634 24.0181 4.44644 23.9769",
    fill: "#D4D9E5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.076 21.9141L30.0746 22.4075L15.499 30.8774L15.5004 30.384L30.076 21.9141Z",
    fill: "#BDC2CE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4517 30.387V30.8805L3.30697 24.4476C3.18051 24.3748 3.10216 24.2387 3.10353 24.093V23.8359L14.4517 30.387V30.387Z",
    fill: "#8394AF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 30.3828V30.8763C15.2103 31.044 14.7416 31.044 14.4502 30.8763V30.3828C14.743 30.5505 15.2117 30.5505 15.5003 30.3828Z",
    fill: "#98ACCB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9718 15.2286C19.0447 15.2698 19.0447 15.3372 18.9732 15.3784L4.44567 23.8208C4.37419 23.8621 4.25736 23.8621 4.18588 23.8208L3.93984 23.6779C3.86836 23.6366 3.86836 23.5693 3.93984 23.528L18.4674 15.0856C18.5388 15.0444 18.6543 15.0444 18.7258 15.0856L18.9718 15.2286V15.2286Z",
    fill: "#302A3E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0271 15.3047V15.4957C19.0258 15.5232 19.0079 15.5494 18.9722 15.57V15.3789C19.0093 15.3583 19.0258 15.3322 19.0271 15.3047Z",
    fill: "#262130"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.226 18.8906V19.0817C25.2246 19.1092 25.2067 19.1353 25.1724 19.1559V18.9648C25.2095 18.9442 25.226 18.9181 25.226 18.8906Z",
    fill: "#262130"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1759 18.9531L25.1745 19.1442L10.647 27.5866L10.6483 27.3955L25.1759 18.9531Z",
    fill: "#262130"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94024 23.685V23.876C3.90312 23.8554 3.88525 23.8279 3.88525 23.8004V23.6094C3.88525 23.6369 3.9045 23.6644 3.94024 23.685Z",
    fill: "#1A1721"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9747 15.375L18.9733 15.5661L4.4458 24.0085L4.44718 23.8174L18.9747 15.375Z",
    fill: "#262130"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18776 23.8148L4.18638 24.0059L3.93896 23.8629L3.94034 23.6719L4.18776 23.8148Z",
    fill: "#1A1721"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44817 23.8203V24.0114C4.37532 24.0526 4.25849 24.0526 4.18701 24.0114V23.8203C4.26124 23.8615 4.37807 23.8615 4.44817 23.8203Z",
    fill: "#1A1721"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64336 24.0912V24.2823C4.60625 24.2617 4.58838 24.2342 4.58838 24.2067V24.0156C4.58838 24.0431 4.60762 24.0706 4.64336 24.0912Z",
    fill: "#1A1721"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3868 27.4013L10.3854 27.5924L4.64258 24.277L4.64395 24.0859L10.3868 27.4013Z",
    fill: "#1A1721"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6479 27.4062V27.5973C10.575 27.6385 10.4582 27.6385 10.3867 27.5973V27.4062C10.4596 27.4475 10.5778 27.4475 10.6479 27.4062Z",
    fill: "#1A1721"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1727 18.8073C25.2442 18.8485 25.2455 18.9158 25.1741 18.9571L10.6466 27.3995C10.5751 27.4407 10.4582 27.4407 10.3868 27.3995L4.64394 24.0841C4.57246 24.0429 4.57246 23.9755 4.64394 23.9343L19.1715 15.4919C19.2429 15.4506 19.3584 15.4506 19.4299 15.4919L25.1727 18.8073V18.8073Z",
    fill: "#302A3E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1714 14.2995L17.8608 14.2101L15.2437 0.8125L15.5543 0.901845L18.1714 14.2995Z",
    fill: "#2A3331"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2931 0.157827L14.9824 0.0671071C15.0993 -0.000245365 15.2161 -0.0153653 15.3178 0.0148746L15.6285 0.105594C15.5254 0.0753543 15.4085 0.0904743 15.2931 0.157827Z",
    fill: "#EBF1FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39268 22.8925L3.08203 22.8018L17.8611 14.2109L18.1717 14.3003L3.39268 22.8925Z",
    fill: "#2A3331"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10459 4.96538L7.79395 4.87466C7.81319 4.88016 7.83518 4.87741 7.85717 4.86504C7.91078 4.83343 7.94377 4.7537 7.9314 4.68635C7.92315 4.64511 7.89978 4.61762 7.87229 4.60938L8.18294 4.7001C8.21181 4.70834 8.2338 4.73583 8.24205 4.77707C8.25579 4.84442 8.2228 4.92414 8.16782 4.95576C8.14583 4.96813 8.12384 4.97088 8.10459 4.96538Z",
    fill: "#77908C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10459 4.96538L7.79395 4.87466C7.81319 4.88016 7.83518 4.87741 7.85717 4.86504C7.91078 4.83343 7.94377 4.7537 7.9314 4.68635C7.92315 4.64511 7.89978 4.61762 7.87229 4.60938L8.18294 4.7001C8.21181 4.70834 8.2338 4.73583 8.24205 4.77707C8.25579 4.84442 8.2228 4.92414 8.16782 4.95576C8.14583 4.96813 8.12384 4.97088 8.10459 4.96538Z",
    fill: "#77908C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11973 4.69679L7.80908 4.60607C7.83107 4.5937 7.85169 4.59095 7.87094 4.59645L8.18158 4.68717C8.16234 4.68167 8.14035 4.68442 8.11973 4.69679Z",
    fill: "#455452"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10277 4.9337L7.79212 4.84298C7.76326 4.83473 7.74126 4.80861 7.73302 4.76738C7.71927 4.69865 7.75363 4.61755 7.80724 4.58594L8.11789 4.67666C8.06428 4.70827 8.02992 4.78799 8.04366 4.8581C8.05191 4.89796 8.0739 4.92545 8.10277 4.9337Z",
    fill: "#455452"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11833 4.69223C8.17193 4.66061 8.22691 4.69085 8.24066 4.75958C8.25441 4.82831 8.22142 4.90666 8.16643 4.93827C8.11145 4.96988 8.05647 4.94102 8.0441 4.87229C8.03173 4.80357 8.06472 4.72247 8.11833 4.69085V4.69223Z",
    fill: "#3C4A48"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3931 22.8946L3.08246 22.8039L0.465332 9.40625L0.775978 9.49697L3.3931 22.8946Z",
    fill: "#252D2C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0.775978 9.4941L0.465332 9.40338L15.2444 0.8125L15.555 0.901845L0.775978 9.4941Z",
    fill: "#333E3D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2923 0.160444C15.5823 -0.00724956 15.8765 0.152197 15.9479 0.51645L18.73 14.7594L3.10836 23.8369L0.326294 9.59529C0.254818 9.22966 0.433508 8.79805 0.723536 8.63173L15.2923 0.160444ZM18.1719 14.3017L15.5548 0.904071L0.775769 9.49632L3.39289 22.894L18.1719 14.3017V14.3017ZM8.11856 4.6978C8.06495 4.72942 8.03059 4.80914 8.04434 4.87924C8.05808 4.94934 8.11306 4.97683 8.16667 4.94522C8.22028 4.9136 8.25327 4.83388 8.2409 4.76653C8.22852 4.69918 8.17354 4.66756 8.11856 4.69918",
    fill: "#302A3E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.113 14.2792L13.5014 16.9596L4.80603 22.0151L3.68441 22.6667L3.38338 22.8426L3.00813 20.921L0.775879 9.49307L10.6891 3.72963L12.9158 2.43618L14.7618 1.36129L15.5054 0.929688L16.9886 8.51302L18.113 14.2792Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0.723732 8.62957L0.413086 8.54023L14.9818 0.0703125L15.2925 0.159658L0.723732 8.62957Z",
    fill: "#EBF1FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10834 23.8401L2.95302 23.7948C2.85817 23.7673 2.78532 23.6889 2.76745 23.5913L0.015625 9.50781L0.326271 9.59853L3.10834 23.8415V23.8401Z",
    fill: "#8394AF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0.326393 9.58552L0.0157472 9.4948C-0.0557289 9.12918 0.122961 8.69757 0.412989 8.53125L0.723635 8.62197C0.433607 8.78966 0.254917 9.22127 0.326393 9.58552",
    fill: "#EBF1FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M3.00813 20.9179L0.775879 9.49001L10.6891 3.72656L3.00813 20.9179Z",
    fill: "url(#paint0_linear_1860_96270)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M14.7615 1.35938L4.80571 22.0132L3.68408 22.6647L12.9155 2.43427L14.7615 1.35938Z",
    fill: "url(#paint1_linear_1860_96270)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.1126 14.274L13.501 16.9544L16.9882 8.50781L18.1126 14.274Z",
    fill: "url(#paint2_linear_1860_96270)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M18.9757 23.4241C15.8844 25.1244 9.38282 28.411 11.2041 29.5889C13.0267 30.7669 17.6727 29.1161 22.7214 26.1828C27.77 23.2496 21.0059 22.308 18.9744 23.4241H18.9757Z",
    fill: "url(#paint3_linear_1860_96270)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3811 24.1187C20.3811 24.1187 20.5158 24.6727 20.5488 25.0259C20.5818 25.3792 20.3138 25.5469 19.9275 25.4452C19.5413 25.3434 18.5173 24.8569 18.3331 24.6562C18.1489 24.4555 18.098 24.2191 18.3331 24.1187C18.5681 24.0184 19.8946 24.2699 19.8946 24.2699V23.8672L20.3811 24.1187Z",
    fill: "#382E2E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4228 23.2879C22.4228 23.2879 22.5438 23.7855 22.574 24.1017C22.6042 24.4178 22.3623 24.569 22.0159 24.4783C21.6695 24.3876 20.75 23.9505 20.5837 23.7704C20.4173 23.5889 20.372 23.3786 20.5837 23.2879C20.7953 23.1972 21.9857 23.424 21.9857 23.424V23.0625L22.4228 23.2879Z",
    fill: "#382E2E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22.985 13.4398L22.75 17.4534V19.485C22.75 20.498 22.7032 22.5969 22.6881 23.2498C22.6854 23.3859 22.5892 23.5028 22.4558 23.5289C22.2978 23.5591 22.0682 23.5536 21.8098 23.4038C21.726 23.3557 21.6737 23.2663 21.6668 23.1701C21.6242 22.4471 21.4291 19.2197 21.3562 18.4926C21.2724 17.6733 21.0552 16.061 21.0552 16.061V13.9786L22.8668 13.2734L22.9864 13.4411L22.985 13.4398Z",
    fill: "#90867C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6822 13.7224L21.4905 14.5787C21.4905 14.5787 20.9695 18.0206 20.9695 18.4577C20.9695 18.8948 20.9365 19.9353 20.9021 21.3621C20.876 22.4741 20.8197 23.6369 20.7949 24.0974C20.7867 24.2541 20.6877 24.3929 20.5393 24.4438C20.4293 24.4809 20.2795 24.5098 20.0788 24.5029C19.5578 24.4864 19.5249 23.9819 19.5249 23.9819C19.5249 23.9819 19.2692 19.5491 19.2376 18.4742C19.206 17.3993 19.0039 13.8736 19.0039 13.8736L19.742 11.9932L22.3619 11.875L22.8636 12.6131L22.6808 13.721L22.6822 13.7224Z",
    fill: "#867D73"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5096 6.1875C23.959 6.92838 23.8917 9.43004 23.8243 9.83278C23.757 10.2355 23.236 10.7386 22.179 10.2603C21.1206 9.78192 23.0257 6.92838 23.0257 6.92838L23.5096 6.1875V6.1875Z",
    fill: "#5C544F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2707 8.4707C15.2707 8.4707 15.026 8.21091 14.9752 8.02122C14.9243 7.83153 14.8831 7.57175 14.6947 7.4123C14.5064 7.25285 14.4556 7.19375 14.4556 7.19375C14.4556 7.19375 14.3841 7.30646 14.4556 7.42467C14.5271 7.54288 14.5738 7.53326 14.5903 7.63497C14.5903 7.63497 14.6494 7.87827 14.4941 7.75731C14.3387 7.63635 13.969 7.47965 13.8439 7.37106C13.7188 7.26247 13.3697 7.11952 13.2652 7.16488C13.1608 7.21024 13.4082 7.38343 13.4082 7.38343C13.4082 7.38343 13.1814 7.23636 13.1017 7.29959C13.0219 7.36282 13.0852 7.40818 13.1814 7.46316C13.2776 7.51814 13.3573 7.56762 13.3573 7.56762C13.3573 7.56762 13.29 7.53463 13.2529 7.60061C13.2157 7.66659 13.4288 7.81229 13.4288 7.81229C13.4288 7.81229 13.3656 7.80267 13.3573 7.87277C13.3491 7.94287 13.5635 8.0707 13.7229 8.23427C13.8824 8.39784 14.3731 8.70437 14.5669 8.76347C14.7607 8.82258 14.9284 8.98615 14.9284 8.98615L15.2734 8.46932L15.2707 8.4707Z",
    fill: "#FFE9D9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6292 8.48771L15.3158 8.30215C15.2787 8.28016 15.2334 8.27466 15.1935 8.28978C15.0904 8.32827 14.8966 8.42449 14.8072 8.62929C14.7303 8.80248 14.7289 8.91932 14.7385 8.9853C14.744 9.02379 14.7688 9.05677 14.8004 9.07877L15.2182 9.36055L15.6292 8.48771Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0537 3.3009C20.0537 3.3009 19.8613 3.54419 19.919 4.48438C19.9781 5.42456 20.0949 5.61837 20.2805 5.63487C20.4661 5.65136 20.7836 5.63487 20.7836 5.63487L20.9265 6.01286L21.8585 5.58401C21.8585 5.58401 21.7746 5.04656 21.7746 4.90361C21.7746 4.76066 22.1183 3.99641 22.1183 3.99641L21.0777 2.80469L20.0537 3.29952V3.3009Z",
    fill: "#FFE9D9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9085 3.06358C19.826 3.30137 19.8687 3.55841 20.079 3.74397C20.2893 3.92954 20.3649 4.03813 20.3649 4.18108C20.3649 4.18108 20.549 3.82782 20.8102 4.01338C21.0714 4.19895 20.8102 4.58382 20.8102 4.58382L21.2047 5.41542L21.8095 5.23673C21.8095 5.23673 21.9346 4.91096 22.0281 4.74327C22.1215 4.57557 22.5408 4.23056 22.5902 3.91167C22.6397 3.59278 22.4817 2.57699 21.6748 2.36669C20.8693 2.15638 20.3992 2.52613 20.281 2.80379C20.281 2.80379 19.9896 2.82853 19.9085 3.06358V3.06358Z",
    fill: "#382E2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6284 6.34527C20.6284 6.34527 20.9721 5.61539 21.5164 5.41334C22.1968 5.1618 22.0703 5.75972 22.0703 5.75972L21.0133 6.44012L20.6284 6.34527V6.34527Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6179 5.54337C21.0819 5.71243 20.6296 6.34885 20.6296 6.34885C20.6296 6.34885 19.5781 6.95364 19.119 7.41961C18.6599 7.88558 17.1988 9.45943 17.1988 9.45943L15.838 8.49313C15.7377 8.42165 15.6112 8.39691 15.4944 8.43265C15.339 8.47938 15.1301 8.5811 15.0009 8.81065C14.8648 9.05394 14.8758 9.31648 14.9074 9.4883C14.9281 9.59963 14.9913 9.69585 15.0848 9.75771C15.4559 10.0024 16.5349 10.7061 16.9335 10.9137C17.4187 11.1652 17.7706 10.9384 19.1878 9.67386L19.3499 10.8738C19.3499 10.8738 18.939 12.4436 18.8634 13.9212C18.8634 13.9212 19.8627 15.7521 21.9863 14.7528C21.9863 14.7528 22.2214 13.4016 22.2544 12.6539L22.5403 14.4751C22.5403 14.4751 23.3127 13.9624 23.3883 13.1487C23.4639 12.335 22.4482 10.1426 22.4482 10.1426C22.4482 10.1426 23.2042 8.41341 23.4475 7.47322C23.6907 6.53304 23.6399 6.09593 23.1698 5.85264C22.8921 5.70831 22.5994 5.66845 22.4056 5.6602C22.3135 5.65608 22.2255 5.61209 22.1746 5.53512C22.1293 5.46914 21.9946 5.42378 21.6193 5.54199L21.6179 5.54337Z",
    fill: "#706760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1860_96270",
    x1: 0.775879,
    y1: 12.3216,
    x2: 10.6891,
    y2: 12.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1860_96270",
    x1: 3.68408,
    y1: 12.0121,
    x2: 14.7615,
    y2: 12.0121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1860_96270",
    x1: 13.501,
    y1: 12.7318,
    x2: 18.1126,
    y2: 12.7318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1860_96270",
    x1: 22.2375,
    y1: 22.5417,
    x2: 14.2624,
    y2: 29.8597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77BBCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D3E9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_96270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.2921,
    height: 31,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLoginType1);
export default __webpack_public_path__ + "static/media/img_login_type1.9d77b55e7f1bd06198da664d7d9192f0.svg";
export { ForwardRef as ReactComponent };